import React from "react";
import { ColorPickerInput } from "../../../../../ui/ColorPickerInput";
import { EditorField, EditorFieldRow } from "../../../../../ui/EditorField";
import { PanelSection } from "../../../../../ui/PanelShell";
import { useMapEditorActions } from "../../../../contexts/MapEditorContext";
import { ShapeSectionOptions } from "../ShapePanel";

export const CommonBorderFillPanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape } = useMapEditorActions();
  const shape = shapes[0];

  const handleToggleFill = () => {
    shapes.forEach((s) => {
      updateShape(s.id, { noFill: !s.noFill });
    });
  };

  const handleStrokeColorChange = (value: string) => {
    shapes.forEach((s) => {
      updateShape(s.id, { stroke: value, strokeWidth: s.strokeWidth || 2 });
    });
  };

  const handleStrokeWidthChange = (value: number | string) => {
    const num = Number(value);
    shapes.forEach((s) => {
      updateShape(s.id, { strokeWidth: num });
    });
  };

  const handleRemoveStroke = () => {
    shapes.forEach((s) => {
      updateShape(s.id, { stroke: undefined, strokeWidth: undefined });
    });
  };

  return (
    <PanelSection label="Border & Fill">
      <div className="flex flex-col gap-2">
        <EditorFieldRow label="Fill">
          <input
            type="checkbox"
            aria-label="Fill"
            checked={!shape.noFill}
            onChange={handleToggleFill}
            className="cursor-pointer rounded"
          />
        </EditorFieldRow>
        <EditorFieldRow label="Border">
          <ColorPickerInput
            value={shape.stroke || ""}
            onChange={handleStrokeColorChange}
            paletteColors={[]}
          />
        </EditorFieldRow>
        <EditorFieldRow label="Width">
          <EditorField
            fieldKey="px"
            label="Border width"
            type="number"
            min={0}
            max={20}
            value={shape.strokeWidth || 0}
            onChange={(e) => handleStrokeWidthChange(e.target.value)}
            containerClassName="w-20"
          />
        </EditorFieldRow>
        {shape.stroke && (
          <button
            type="button"
            className="self-start text-blue-600 text-xs hover:text-blue-800"
            onClick={handleRemoveStroke}
          >
            Remove border
          </button>
        )}
      </div>
    </PanelSection>
  );
};
